// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "didi-unify-bridge" + "." + "e999bb024f13e10daacb" + ".js";
};